import styled from 'styled-components';

const ChartWrapper = styled.div`
  width: 100%;
  height: 100%;
  .venntooltip {
    position: absolute;
    text-align: center;
    background: #000000;
    opacity: 0;
    color: #ffffff;
    padding: 2px;
    min-width: 128px;
    border-radius: 8px;
  }
`;
export { ChartWrapper };
